import { Box, Button, CircularProgress, Grid, Tooltip } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { viewImage } from "../../utils/viewPDF";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import InfoIcon from "@mui/icons-material/Info";
// import { uploadFile } from "../../utils/uploadToAzure";

/* ---------- Direction C tokens (styling only) ---------- */
const FONT = "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif";
const MONO = "'IBM Plex Mono', ui-monospace, monospace";
const INK = "#0F1B2A";
const INK_2 = "#3D4C60";
const LINE = "#E4E9EF";
const FIELD_EDGE = "#D5DEE7";
const PRIMARY = "#0B5C8A";
const ERROR = "#C42B24";

const labelStyle = {
  display: "block",
  marginBottom: 6,
  fontFamily: FONT,
  fontSize: 12,
  fontWeight: 600,
  color: INK_2,
};
const inputStyle = (hasError) => ({
  display: "block",
  width: "100%",
  boxSizing: "border-box",
  height: 42,
  padding: "0 12px",
  margin: 0,
  background: "#FFFFFF",
  border: `1px solid ${hasError ? ERROR : FIELD_EDGE}`,
  borderRadius: 10,
  fontFamily: FONT,
  fontSize: 14,
  color: INK,
  outline: "none",
});
const errorStyle = {
  margin: "5px 0 0",
  fontFamily: FONT,
  fontSize: 12,
  fontWeight: 500,
  color: ERROR,
};
const btnBase = {
  height: 42,
  px: 2.5,
  borderRadius: "10px !important",
  fontFamily: FONT,
  fontSize: 14,
  fontWeight: 600,
  textTransform: "none",
  boxShadow: "none",
};

const OrgDetails = () => {
  const [org, setOrg] = useState();
  const [errors, setErrors] = useState("");
  const navigate = useNavigate();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [fileNames, setFileNames] = useState({ orgLogo: "" });
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const orgId = JSON.parse(localStorage.getItem("org"));

  useEffect(() => {
    const getOrg = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/organization/get-by-admin?username=${storedUser.username}&orgId=${orgId}`,
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      setOrg(res.data);
      if (res.data.orgLogo && res.data.orgUsername && res.data.orgShortform) {
        navigate(`/dashboard`);
      }
    };
    getOrg();
  }, []);

  const handleChange = (e) => {
    const updatedValue = e.target.name === "orgShortform" ? e.target.value.toUpperCase() : e.target.value;
    setOrg({ ...org, [e.target.name]: updatedValue });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};
    const data = org || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    // if (isEmpty(data.orgLogo)) newErrors.orgLogo = "Org Logo is required";
    if (isEmpty(data.orgUsername))
      newErrors.orgUsername = "Org Username is required";
    if (isEmpty(data.orgShortform)) {
      newErrors.orgShortform = "Org Shortform is required";
    } else if (!/^[A-Z0-9]{3}$/.test(data.orgShortform)) {
      newErrors.orgShortform =
        "Must be exactly 3 uppercase characters with no special characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFileUpload = async (e) => {
    const { name, files } = e.target;
    setUploading(true);
    if (files && files.length > 0) {
      const file = files[0];

      // Validate image dimensions
      const image = new Image();
      const objectUrl = URL.createObjectURL(file);
      image.src = objectUrl;

      image.onload = async () => {
        const { width, height } = image;

        URL.revokeObjectURL(objectUrl); // Cleanup

        if (width < 400 || width > 600 || height < 400 || height > 600) {
          setErrors((prev) => ({
            ...prev,
            [name]:
              "Image dimensions must be between 400 and 600 pixels (both width and height)",
          }));
          setUploading(false)
          return;
        }

        // Continue with upload
        setFileNames((prev) => ({
          ...prev,
          [name]: file.name,
        }));

        const formData = new FormData();
        formData.append("file", file);

        try {
          // const res = await uploadFile(file, org.orgId, null, null, storedUser)
          const res = "default";
          setOrg({ ...org, orgLogo: res });
          setErrors({ ...errors, orgLogo: "" });
        } catch (error) {
          console.error("File upload error:", error);
        } finally {
          setUploading(false);
        }
      };

      image.onerror = () => {
        setErrors((prev) => ({
          ...prev,
          [name]: "Invalid image file",
        }));
      };
    }
  };

  const handleUpdate = async () => {
    if (!validateForm()) return;
    setLoading(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/organization?orgId=${org.orgId}`,
        {
          // orgLogo: org.orgLogo,
          orgUsername: org.orgUsername,
          orgShortform: org.orgShortform,
        },
        { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
      );
      navigate(`/dashboard`);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate(`/dashboard`);
  };
  return (
    <div style={{ position: "relative", fontFamily: FONT, color: INK, padding: "8px 0 24px" }}>
      {loading && <div className="loading-div"></div>}
      <div
        className="dashboard-container"
        style={{
          width: "100%",
          maxWidth: 720,
          margin: "0 auto",
          boxSizing: "border-box",
          background: "#FFFFFF",
          border: `1px solid ${LINE}`,
          borderRadius: 14,
          padding: 0,
          overflow: "hidden",
        }}
      >
        <div style={{ padding: "18px 22px 14px", borderBottom: "1px solid #EDF1F5" }}>
          <h2
            style={{
              margin: 0,
              fontFamily: FONT,
              fontSize: 22,
              fontWeight: 800,
              letterSpacing: "-0.025em",
              color: INK,
            }}
          >
            Enter Organization Details
          </h2>
        </div>
        <Grid
          container
          columnSpacing={2}
          rowSpacing={2}
          sx={{ width: "100%", margin: 0, px: { xs: 2, sm: 2.75 } }}
          py={2.5}
        >
          {/* <Grid size={{ xs: 12, sm: 6 }}>
            <label htmlFor="orgLogo">
              <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}>
                <div>
                  Organization Logo<span style={{color: '#FF0000'}}>*</span>
                </div>
                <Tooltip title="Please upload logo between 400 and 600 pixels">
                  <InfoIcon fontSize="small" />
                </Tooltip>
              </div>
              <div className={`input-file ${errors.orgLogo && "input-error"}`}>
                <input
                  type="file"
                  id="orgLogo"
                  name="orgLogo"
                  onChange={handleFileUpload}
                />
                <span
                  style={{
                    width: "80%",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {fileNames.orgLogo || "No file chosen"}
                </span>
                <AttachFileIcon
                  fontSize="small"
                  sx={{
                    color: "#555",
                    transform: "rotate(90deg)",
                    "&:hover": { color: "#1A71F6BF" },
                  }}
                />
              </div>
            </label>
            {uploading && <CircularProgress />}
            {errors.orgLogo && <p className="error">{errors.orgLogo}</p>}
            {org && org.orgLogo && (
              <Button
                sx={{
                  margin: "-10px 0 10px 0 !important",
                  padding: "0 !important",
                  width: "max-content !important",
                  fontSize: "12px !important",
                  textDecoration: "underline",
                  textAlign: "start",
                }}
                onClick={() => viewImage(org.orgLogo, storedUser)}
              >
                {fileNames.orgLogo}
              </Button>
            )}
          </Grid> */}
          <Grid size={{ xs: 12, sm: 6 }}>
            <label htmlFor="orgUsername" style={labelStyle}>
              Organization Username (in smallcase)<span style={{ color: ERROR, marginLeft: 2 }}>*</span>
            </label>
            <input
              type="text"
              id="orgUsername"
              name="orgUsername"
              onChange={handleChange}
              value={org && org.orgUsername}
              className={`${errors.orgUsername && "input-error"}`}
              style={inputStyle(!!errors.orgUsername)}
            />
            {errors.orgUsername && (
              <p className="error" style={errorStyle}>{errors.orgUsername}</p>
            )}
          </Grid>
          <Grid size={{ xs: 12, sm: 6 }}>
            <label
              htmlFor="orgShortform"
              style={{
                ...labelStyle,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div>
                Organization Shortform (3 letters)<span style={{ color: ERROR, marginLeft: 2 }}>*</span>
              </div>
              <Tooltip
                title="We use your 3 letter shortform in your tender ID e.g. ARG_A_2025_654321"
                componentsProps={{
                  tooltip: { sx: { background: INK, fontFamily: FONT, fontSize: 12, borderRadius: "7px" } },
                }}
              >
                <InfoIcon sx={{ fontSize: 16, color: "#8A97A8", cursor: "help", "&:hover": { color: PRIMARY } }} />
              </Tooltip>
            </label>
            <input
              type="text"
              id="orgShortform"
              name="orgShortform"
              onChange={handleChange}
              value={org && org.orgShortform}
              className={`${errors.orgShortform && "input-error"}`}
              maxLength={3}
              style={{
                ...inputStyle(!!errors.orgShortform),
                fontFamily: MONO,
                fontSize: 14,
                fontWeight: 600,
                letterSpacing: "0.18em",
              }}
            />
            {errors.orgShortform && (
              <p className="error" style={errorStyle}>{errors.orgShortform}</p>
            )}
          </Grid>
        </Grid>
      </div>
      <Box
        className="btn-container"
        sx={{
          gap: 1.25,
          display: "flex",
          justifyContent: "flex-end",
          flexWrap: "wrap",
          maxWidth: 720,
          mx: "auto",
          mt: 2,
        }}
      >
        <Button
          className="btn-outlined"
          onClick={handleBack}
          sx={{
            ...btnBase,
            background: "#FFFFFF !important",
            color: `${INK} !important`,
            border: `1px solid ${FIELD_EDGE} !important`,
            "&:hover": { background: "#F4F7FA !important" },
          }}
        >
          Back
        </Button>
        <Button
          className="btn-contained"
          onClick={handleUpdate}
          sx={{
            ...btnBase,
            background: `${PRIMARY} !important`,
            color: "#FFFFFF !important",
            border: "0 !important",
            "&:hover": { background: "#084767 !important" },
          }}
        >
          Submit
        </Button>
      </Box>
    </div>
  );
};

export default OrgDetails;
